export default __webpack_public_path__ + "static/Inter-Bold-36a650f426faae9edc535a1495699a25.woff2";